import { toast } from "react-toastify";
export class CommonUtil {
  static appId = "";

  static parseData(data: any): any {
    if (data) {
      var restData = JSON.parse(data);
      if (restData) {
        return restData;
      }
    }
    return null;
  }
}
export const showToast = (type: any, msg: any) => {
  switch (type) {
    case "SUCCESS":
      toast.success(msg, {
        position: "bottom-right",
      });
      break;
    case "ERROR":
      toast.error(msg, {
        position: "bottom-right",
      });
      break;
    case "WARNING":
      toast.warn(msg, {
        position: "bottom-right",
      });
      break;
    default:
      return false;
  }
};

export const readJson = (key: string, fallback = {}) => {
  try {
    return JSON.parse(localStorage.getItem(key) || "") || fallback;
  } catch {
    return fallback;
  }
};
